import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useIncompleteTimesheetApi = () => {
    const { getDataAsync } = useApi();

    const getIncompleteTimesheetApiCall = useCallback(
        async (employeeId) => {
            const response = await getDataAsync("incompleteTimesheets", {
                urlParams: [{ name: "$employeeId", value: employeeId }],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useIncompleteTimesheet = (employeeId) =>
            useQuery(["incompleteTimesheets", employeeId], () =>
                getIncompleteTimesheetApiCall(employeeId)
            );

        return {
            useIncompleteTimesheet,
        };
    }, [getIncompleteTimesheetApiCall]);
};

export default useIncompleteTimesheetApi;
